export class AwardSalesRequest {
  showClaim: boolean | null;
  showUnclaim: boolean | null;
  invoiceIds?: number[] | null;
  destinationUserId: number | null;
  destinationUserEmail: string | null;
}
